<template>
  <router-link v-if="!(product && product.tiptiles)" :to="'/product/' + slug + '?gte' + '=' + product.genderType">
    <div class="special-products" :id="product && 'productlist-' + product.id">
      <div class="product-card-container">
        <div class="listhoverimg" :style="'background-image: url('+baseImgPath+imgSize+IMG_URL+secondaryImage+')'"></div>
        <img class="product-card" :src="baseImgPath+imgSize+IMG_URL+image" :alt="`Shop ${name} ${category}`" :title="`Shop ${name} ${category}`"/>
        <div :class="showImageBlurSoldOutDesign ? 'souled-out-image-blur': 'souledout'" v-if="prodType === 1 && pstock <= 0">{{showImageBlurSoldOutDesign ? 'Souled Out' : ''}}</div>
        <div :class="showImageBlurSoldOutDesign ? 'souled-out-image-blur': 'souledout'" v-if="prodType === 3 && isStockConfig <= 0">{{showImageBlurSoldOutDesign ? 'Souled Out' : ''}}</div>
      </div>
      <div class="special-products__info">
        <span class="special-products__name">{{name}}</span>
        <span class="special-products__category">{{category}}</span>
        <span v-if="Math.round(splPrice)">
          <div class="row">
            <div class="col-8 special-products_pricing">
              <span class="special-products__price fsemibold fred">₹ {{ Math.round(splPrice) }}</span>
              <span class="special-products__price--striked fsemibold">₹ {{ Math.round(price) }}</span>
            </div>
            <div class="col-4 special-products_pricing text-right">
              <span class="percentage-off" v-if="isExclusive || splPrice > 0">{{`${Math.round((price - (isExclusive ? exclusivePrice : splPrice)) / price * 100)}%`}} OFF</span>
            </div>
          </div>
        </span>
        <span v-else class="special-products__price fsemibold">₹ {{ Math.round(price) }}</span>
      <!-- <div class="ex-price" @click="togglePopup(EXCLUSIVE_PRODUCT)">For Excl. Member <i class="fa fa-info-circle pointer"></i><span class="fbold" style="float: right;">₹ 499</span></div> -->
      </div>
    </div>
  </router-link>
  <div v-else class="special-products" :id="'productlist-tiptile-' + product.tiptiles.id">
    <div class="product-card-container">
      <a v-if="product.tiptiles.isClickable && product.tiptiles.navLink && isExternalLink(product.tiptiles.navLink)" :href="product.tiptiles.navLink" target="_blank" rel="noopener noreferrer">
        <img class="product-card" :src="image" :alt="name" :title="name" @load="loadimage"/>
      </a>
      <router-link v-else-if="product.tiptiles.isClickable && product.tiptiles.navLink" :to="product.tiptiles.navLink"  :class="'listhover ' + pclass">
        <img class="product-card" :src="image" :alt="name" :title="name" @load="loadimage"/>
      </router-link>
      <div v-else class='pointer-none'>
        <img class="product-card" :src="image" :alt="name" :title="name" @load="loadimage"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import ZoomOnHover from 'vue-zoom-on-hover'
  Vue.use(ZoomOnHover)
  export default {
    name: 'collection',
    props: ['image', 'secondaryImage', 'category', 'alt', 'slug', 'name', 'price', 'splPrice', 'product', 'pstock', 'isStockConfig', 'prodType', 'scrollToProduct', 'isExclusive', 'exclusivePrice', 'showImageBlurSoldOutDesign'],
    data () {
      return {
        baseImgPath: process.env.IMG_BASE_URL,
        imgSize: 'cdn-cgi/image/width=300,height=400,quality=100/',
        IMG_URL: process.env.PRODUCT_IMG
      }
    },
    methods: {
      loadimage () {
        this.scrollToProduct()
      },
      isExternalLink: function (navLink) {
        return navLink && typeof navLink === 'string' && navLink.startsWith('http')
      }
    }
  }
</script>


<style scoped>
.special-products {
  margin: 0;
  transition: all 0.5s;
  margin: 5px 0;
}
.percentage-off {
  font-weight: bold;
  font-size: 14px;
  color: #ed2d2f;
}
.souledout {
  z-index: 5;
}

.ex-price {
  color: #3498db;
  font-size: 12px;
}

.special-products:hover {
    box-shadow: none;
  }

.product-card-container {
  position: relative;
}

.product-card {
  display: block;
  width:100%;
  object-fit: cover;
  transition: opacity 0.3s ease-in-out;
}

.special-products__name {
  color: #5a5a5a;
  display: block;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
}

.special-products__category {
  display: block;
  color: #939598;
  font-size: 13px;
}

.special-products__info {
  line-height: 15px;
}

.special-products__price {
  color: #232323;
  font-size: 12px;
}

.special-products__price--striked {
  color: #ccc;
  text-decoration: line-through;
  margin-left: 5px;
  font-size: 12px;
}

.special-products__price.fred {
  color: #ed2d2f;
}

.special-products__info {
  padding: 10px;
}

@media (min-width: 768px) {
  .special-products {
    margin: 10px;

  }


  .special-products__info {
    padding: 6px 15px;
    line-height: 18px;
  }

  .special-products__name {
    font-size: 14px;
  }

  .special-products__price {
    font-size: 16px;
  }
}

@media screen and (max-width: 1024px) {
  .percentage-off {
    font-size: 12px;
  }
  .special-products_pricing {
    padding-left: 5px !important;
    padding-right: 5px !important; 
  }
}

@media screen and (max-width: 1024px) {
  .special-products_pricing {
    padding-left: 5px !important;
    padding-right: 0px !important; 
  }
}

@media (max-width: 576px) {
  .special-products__category {
    font-size: 12px;
  }

  .special-products:nth-child(1) {
    border-left: none
  }
}

@media screen and (max-width: 480px) {
    .percentage-off {
      font-size: 11px;
    }
  }
  @media screen and (max-width: 320px) {
    .percentage-off {
      font-size: 9px;
    }
  }

</style>



// WEBPACK FOOTER //
// Product.vue?6d5de7f0